/**
 * 2007-2019 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-touchspin';
import Swiper from 'swiper/dist/js/swiper.min';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import MainMenu from './components/main-menu';
import ProductSelect from './components/product-select';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let dropDown = new DropDown(dropDownEl);
  let productSelect  = new ProductSelect();
  let mainMenu = new MainMenu();
  dropDown.init();
  form.init();
  mainMenu.init();
  productSelect.init();
  /*$("#products").bind("DOMSubtreeModified", function() {
    productMinitature.init();
  });*/

  function hasTouchscreen() {
    var result = false;
    if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
      // if Pointer Events are supported, just check maxTouchPoints
      if (navigator.maxTouchPoints > 0) {
        result = true;
      }
    } else {
      // no Pointer Events...
      if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
        // check for any-pointer:coarse which mostly means touchscreen
        result = true;
      } else if (window.TouchEvent || ('ontouchstart' in window)) {
        // last resort - check for exposed touch events API / event handler
        result = true;
      }
    }
    return result;
  }

  // homeslider
  var homeslider_swiper = new Swiper('.homeslider-container .swiper-container', {
    speed: 1000,
    autoplay: {
      delay: $('.homeslider-container').data('interval'),
      disableOnInteraction: true,
    },
    loop: $('.homeslider-container').data('wrap'),
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '#homeslider-next',
      prevEl: '#homeslider-prev',
    },
  });

  // carousel product page
  $('.page-product #main .block-product-list .swiper-container, .cross-selling .swiper-container').find('.product-miniature').addClass('swiper-slide');
  new Swiper('.page-product #main .block-product-list .swiper-container, .cross-selling .swiper-container', {
    slidesPerView: 'auto',
    grabCursor: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  
  // carouel columns (vertical), in sidebar
  var i=0;
  $('.sidebar .jq_carousel').each(function() {
    $(this).addClass('swiper-wrapper').wrap('<div class="swiper-container swiper-container-' + i + '"></div>').find('.product-miniature').addClass('swiper-slide');
    $('<div class="swiper-button-prev"/><div class="swiper-button-next"/>').insertAfter(this);
    new Swiper('.sidebar .swiper-container-' + i, {
      direction: 'vertical',
      autoplay: {
        delay: 5000,
      },
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    i++;
  });

  // Back to top
  if($(window).width()>600) {
    $('body').prepend('<div id="toTop">Top</div>');

    $(window).scroll(function() {
      if($(this).scrollTop() != 0) {
        $('#toTop').fadeIn();
      } else {
        $('#toTop').fadeOut();
      }
    });

    $('#toTop').click(function() {
      $('body,html').animate({scrollTop:0},800);
    });
  };

  $('body').on('click', '.pswp__button--close', function() {
    setTimeout(function(){
      $('.pswp.pswp--open').removeClass('pswp--open');
    }, 1000);    
  });

  NbCols();

  $(window).resize(function() {
    NbCols();
  });
});

var NbCols = function () {
  // count columns in content column
  jQuery('#content-wrapper').attr('data-nb-cols', Math.floor((jQuery('#content-wrapper').width() + 15) / 195));

  // count columns in footer
  jQuery('.footer-container > .container:first-child').attr('data-nb-cols', Math.floor((jQuery('.footer-container > .container:first-child').width() + 15) / 195));
}
